namespace RioERP.Orders {
    export interface CustomerGiftCardsForm {
        CustomerId: Serenity.IntegerEditor;
        OrderId: Serenity.IntegerEditor;
        NopOrderId: Serenity.StringEditor;
        Amount: Serenity.DecimalEditor;
        Percentage: Serenity.DecimalEditor;
        GiftCardCode: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
    }

    export class CustomerGiftCardsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.CustomerGiftCards';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomerGiftCardsForm.init)  {
                CustomerGiftCardsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DateEditor;

                Q.initFormType(CustomerGiftCardsForm, [
                    'CustomerId', w0,
                    'OrderId', w0,
                    'NopOrderId', w1,
                    'Amount', w2,
                    'Percentage', w2,
                    'GiftCardCode', w1,
                    'IsActive', w3,
                    'InsertUserId', w0,
                    'InsertDate', w4,
                    'UpdateUserId', w0,
                    'UpdateDate', w4
                ]);
            }
        }
    }
}
